export enum FitnessKitEnum {
  GOOGLE = 'GOOGLEFIT',
  APPLE = 'HEALTHKIT'
}
